var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.9974 12.8332C3.77565 12.8332 1.16406 10.2216 1.16406 6.99984C1.16406 3.77809 3.77565 1.1665 6.9974 1.1665C10.2191 1.1665 12.8307 3.77809 12.8307 6.99984C12.8307 10.2216 10.2191 12.8332 6.9974 12.8332ZM6.9974 11.6665C8.23507 11.6665 9.42206 11.1748 10.2972 10.2997C11.1724 9.4245 11.6641 8.23751 11.6641 6.99984C11.6641 5.76216 11.1724 4.57518 10.2972 3.70001C9.42206 2.82484 8.23507 2.33317 6.9974 2.33317C5.75972 2.33317 4.57273 2.82484 3.69756 3.70001C2.82239 4.57518 2.33073 5.76216 2.33073 6.99984C2.33073 8.23751 2.82239 9.4245 3.69756 10.2997C4.57273 11.1748 5.75972 11.6665 6.9974 11.6665V11.6665ZM7.58073 6.99984H9.91406V8.1665H6.41406V4.08317H7.58073V6.99984Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeline);
export default __webpack_public_path__ + "static/media/Timeline.3ed6d3d27b04dbb81a851bfeb3c9d404.svg";
export { ForwardRef as ReactComponent };